<sc-sub-title><sc-dictionary-label
dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.tasks-title"></sc-dictionary-label></sc-sub-title>
<sc-content-spacer vertical></sc-content-spacer>
@if (tasks == null || tasks.length === 0) {
  <sc-no-data compact></sc-no-data>
}
@for (task of tasks; track task; let i = $index) {
  @if (i > 0) {
    <sc-content-spacer vertical></sc-content-spacer>
  }
  <app-task-item [task]="task" [transportId]="transportId" (changed)="handleTaskItemChanged($event)"></app-task-item>
}
